<template>
  <div id="service-energy">
    <BaseTitle
      pageTitle="Compliance"
      :pageSubtitle="$t('compliancePagesubTitle')"
    >
    </BaseTitle>
    <div class="service-wrapper">
      <div class="service-title">
        提供第三方支付服務之事業或人員洗錢防制及服務能量登錄
      </div>
      <img
        src="../assets/imgs/home/service-energy-01.jpg"
        class="service-energy-image"
      />
      <img
        src="../assets/imgs/home/service-energy-02.jpg"
        class="service-energy-image"
      />
      <img
        src="../assets/imgs/home/service-energy-03.jpg"
        class="service-energy-image"
      />
    </div>
  </div>
</template>

<script>
import BaseTitle from "@/components/BaseTitle";

export default {
  metaInfo: {
    title: "Home",
  },
  components: {
    BaseTitle,
  },
};
</script>

<style lang="scss" scoped>
@import "./src/assets/sass/main.scss";

/deep/ {
  .about-tabs {
    display: none;
  }
}
.top-banner {
  position: relative;
  margin-top: 30px;
  .banner-photo {
    width: 80%;
    height: 270px;
    background-image: url("../assets/imgs/page-banner/contact.png");
    background-size: cover;
    background-position: center;
  }
  .banner-deco {
    position: absolute;
    top: -30px;
    z-index: -1;
    height: 270px;
    width: 60%;
    background: $lightBlue;
  }
}

.service-title {
  font-size: 15px;
  margin-bottom: 20px;
  margin-top: 40px;
}

.service-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0px 60px 50px 60px;
  @media screen and (max-width: 900px) {
    padding: 50px;
  }
  @media screen and (max-width: 720px) {
    padding: 50px 30px;
  }
}

.service-energy-image {
  width: 90%;
  max-width: 650px;
  margin-bottom: 20px;
  border: 1px solid #9b9b9b;
  :last-child {
    margin-bottom: 40px;
  }
}

/deep/ {
  #base-title {
    .top-banner {
      .banner-photo {
        background-image: url("../assets/imgs/page-banner/contact.png");
      }
    }
  }
}
</style>
